import { getMessaging } from "firebase/messaging";
import { firebaseApp } from "./firebaseConfig";

export const messaging = getMessaging(firebaseApp);
